module.exports = __webpack_public_path__ + "static/img/Geoff-Toovey.5a19109.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Geoff-Toovey.jpg
// module id = eGhi
// module chunks = 0